import moment, { isMoment } from 'lib/utils/date';

const formatRelative = (date) => {
  const isYesterday = moment().diff(date, 'day') === 1;
  const isToday = moment().diff(date, 'day') === 0;
  const isTomorrow = moment().diff(date, 'day') === -1;

  if (isYesterday) {
    return 'common.yesterday';
  }

  if (isToday) {
    return 'common.today';
  }

  if (isTomorrow) {
    return 'common.tomorrow';
  }

  return date.format('DD.MM.YY');
};

// TODO: @danealton данные инструмены додлжны быть вынесены в методы или миксины
export default {
  install(Vue) {
    if (this.installed) {
      return;
    }

    this.installed = true;

    Vue.filter('date', (value, _format) => {
      if (!value) {
        return;
      }

      value = moment(value);

      if (_format === 'calendar') {
        return formatRelative(value);
      }

      return value.format(_format);
    });

    Vue.prototype.$date = (value, _format) => {
      if (!value) {
        return;
      }

      const result = isMoment(value) ? value : moment(value);

      return result.format(_format);
    };
  },
};
